export default __webpack_public_path__ + "static/media/newTag.4226d787.svg";